/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

export interface IImageModalProps {
  showModal: boolean;
  imageSrc?: string;
  onDeny?(): void;
}

export const ImageModal = ({
  showModal,
  onDeny,
  imageSrc,
}: IImageModalProps) => {
  const _onDeny = () => {
    if (onDeny) {
      onDeny();
    }
  };
  if (showModal && imageSrc) {
    //@ts-ignore
    return <Lightbox mainSrc={imageSrc} onCloseRequest={_onDeny} />;
  }
  return null;
};

ImageModal.defaultProps = {
  showModal: false,
};
